// @mui material components
import { styled } from "@mui/material/styles";
import Slider from "react-slick";

// Material Kit 2 React components
import MKBox from "components/MKBox";
// import MKTypography from "components/MKTypography";

// Images
import slider1 from "assets/images/bg-college.webp";
import slider2 from "assets/images/snlc-bg-2.webp";

const SingleSlider = styled("div")({
  marginRight: "10px",
});
// const SlidertextBox = styled("div")({
//   backgroundColor: "rgba(255, 255, 255,0.8)",
//   width: "50%",
//   padding: 15,
//   display: "flex",
//   alignItems: "center",
//   marginTop: "15%",
//   marginLeft: "20%",
// });

function HomeSlider() {
  const homesettings = {
    dots: true,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <MKBox width="100%" id="home-slider">
      <Slider {...homesettings}>
        <SingleSlider
          sx={{
            backgroundImage: `url(${slider1})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
          }}
          className="slider"
        >
          {/* <SlidertextBox>
            <MKTypography
              sx={{
                color: "rgba(10, 10, 10, 0.8)",
                fontSize: "70px",
                lineHeight: "75px",
                textAlign: "center",
                textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25);",
                textTransform: "capitalize",
              }}
            >
              earn your degree in
              <br /> legal studies at SNLC
            </MKTypography>
          </SlidertextBox> */}
        </SingleSlider>
        <SingleSlider
          sx={{
            backgroundImage: `url(${slider2})`,
            backgroundSize: "cover",
            backgroundPosition: "top",
          }}
          className="slider"
        >
          &nbsp;
        </SingleSlider>
      </Slider>
    </MKBox>
  );
}

export default HomeSlider;
